// 引入公共组件
import Vue from 'vue';
import Router from 'vue-router';
import Hello from 'components/Hello';
import tab from 'components/tab';

// 引入组件
import baseservice from '../page/baseservice/index.vue'
import pettyloan from '../page/pettyloan/index.vue'
import imfbpXd from '../page/imfbpXd/index.vue'
import imfbpRz from '../page/imfbpRz/index.vue'
import bmp from '../page/bmp/index.vue'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
      {
        path: '/',
        name: '/',
        component: baseservice,
      },
      {
        path: '/baseservice',
        name: 'baseservice',
        component: baseservice,
      },
      {
        path: '/imfbpXd',
        component:imfbpXd,
      },
      {
        path:'/imfbpRz',
        component:imfbpRz,
      },
      {
        path:'/bmp',
        component:bmp,
      },
  // 小贷业务系统板块 begin
    //基础档案
      {
        path:'/xdProduct',
        component:tab
      },
      {
        path:'/xdParamset',
        component:tab
      },
    //客户管理
      {
        path:'/xdPerCust',
        component:tab
      },
      {
        path:'/xdEntCust',
        component:tab
      },
    //贷前管理
      {
        path:'/xdPreLoanapp',
        component:tab
      },
      {
        path:'/xdPreLoandoc',
        component:tab
      },
    //贷中管理
      {
        path:'/xdLoanTask',
        component:tab
      },{
        path:'/xdLoanContract',
        component:tab
      },{
        path:'/xdLoanDuebill',
        component:tab
      },
    //贷后管理
      {
        path:'/xdInterestCalctor',
        component:tab
      },
      {
        path:'/xdLoanPayplan',
        component:tab
      },{
        path:'/xdLoanMonite',
        component:tab
      },{
        path:'/xdLoanFivestatus',
        component:tab
      },{
        path:'/xdRepaymentPrincipal',
        component:tab
      },
      {
        path:'/xdLoanProcess',
        component:tab
      },
      {
        path:'/xdLoanPayment',
        component:tab
      },{
        path:'/xdContractChange',
        component:tab
      },{
        path:'/xdRateChange',
        component:tab
      },{
        path:'/xdContractRenewal',
        component:tab
      },{
        path:'/xdContractEnd',
        component:tab
      },
    //报表
      {
        path:'/loanItemReport',
        component:tab
      },
      {
        path:'/xdContractReport',
        component:tab
      },
      {
        path:'/xdCustTallyDetail',
        component:tab
      },
      {
        path:'/xdCustTallyBalance',
        component:tab
      },
  // 小贷业务系统板块 end
  // 融资租赁系统板块 begin
    //基础档案
      {
        path:'/rzBaseParam',
        component:tab
      },
      {
        path:'/rzRecptpmt',
        component:tab
      },
      {
        path:'/rzRate',
        component:tab
      },
      {
        path:'/rzEqpt',
        component:tab
      },
    //客户管理
      {
        path:'/crmEnterpriseclient',
        component:tab
      },
      {
        path:'/crmConsumerclient',
        component:tab
      },
      {
        path:'/crmContacts',
        component:tab
      },
    //模板管理
      {
        path:'/templateDef',
        component:tab
      },
      {
        path:'/template',
        component:tab
      },
    //租前管理
      {
        path:'/rzPricecal',
        component:tab
      },
      {
        path:'/rzPrjapply',
        component:tab
      },
      {
        path:'/rzPrjreview',
        component:tab
      },
      {
        path:'/rzPrjcontr',
        component:tab
      },
    //租后管理
      {
        path:'/rzPmtPlan',
        component:tab
      },
      {
        path:'/rzAdjInt',
        component:tab
      },
      {
        path:'/rzPrjcontrChg',
        component:tab
      },
      {
        path:'/rzPlanChange',
        component:tab
      },
      {
        path:'/rzDefInterest',
        component:tab
      },
      {
        path:'/rzPrjcontrEqptmngr',
        component:tab
      },
      {
        path:'/rzAssetRiskclass',
        component:tab
      },
    //报表
      {
        path:'/rzContrTallyProQuery',
        component:tab
      },
      {
        path:'/rzContrTally',
        component:tab
      },
      {
        path:'/rzContrTallyDetail',
        component:tab
      },
  // 融资租赁系统板块 end
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js